// ============================================
// Creator Events - Situational Images
// 상황별 이미지 이벤트 핸들러
// ============================================

import {
  openSituationalImageModal,
  closeSituationalImageModal,
  saveSituationalImage,
  deleteSituationalImage,
  openSituationalImageSelector,
  initSituationalDescCounter,
  toggleSituationalSection
} from '../editor/situational.js';

// ============================================
// 이벤트 초기화
// ============================================

export function initSituationalImageEvents() {
  // 고급 탭 이벤트 위임
  const advancedTab = document.getElementById('editorTabAdvanced');
  advancedTab?.addEventListener('click', handleAdvancedTabClick);

  // 모달 이벤트
  const modal = document.getElementById('situationalImageModal');
  modal?.addEventListener('click', handleModalClick);

  // 설명 입력 카운터 초기화
  initSituationalDescCounter();
}

// ============================================
// 이벤트 핸들러
// ============================================

function handleAdvancedTabClick(e) {
  const actionEl = e.target.closest('[data-action]');
  if (!actionEl) return;

  const action = actionEl.dataset.action;
  const index = actionEl.dataset.index;

  switch (action) {
    case 'toggleSituationalSection':
      toggleSituationalSection();
      break;
    case 'addSituationalImage':
      openSituationalImageModal();
      break;
    case 'editSituational':
      e.stopPropagation();
      openSituationalImageModal(parseInt(index));
      break;
    case 'deleteSituational':
      e.stopPropagation();
      deleteSituationalImage(parseInt(index));
      break;
  }
}

function handleModalClick(e) {
  const actionEl = e.target.closest('[data-action]');
  if (!actionEl) return;

  const action = actionEl.dataset.action;

  switch (action) {
    case 'closeSituationalModal':
      closeSituationalImageModal();
      break;
    case 'saveSituationalImage':
      saveSituationalImage();
      break;
    case 'selectSituationalImage':
      openSituationalImageSelector();
      break;
  }
}
